export default __webpack_public_path__ + "static/media/Validações (Real Size).b16431b4.svg";